import { configureStore } from '@reduxjs/toolkit';
import alertReducer from './reducers/global/alerts/alertSlice';
import editorReducer from './reducers/global/editor/editorSlice';
import edgeReducer from './reducers/global/edge/edgeSlice';
import inspectorReducer from './reducers/global/inspector/inspectorSlice';
import nodeReducer from './reducers/global/node/nodeSlice';
import diagramReducer from './reducers/global/diagram/diagramSlice';
import historyReducer from './reducers/global/history/historySlice';
import modalReducer from './reducers/global/modal/modalSlice';
import folderReducer from './reducers/global/folder/folderSlice';
import distributionBoardReducer from './reducers/global/distributionBoard/distributionBoardSlice';
import viewReducer from './reducers/global/view/viewSlice';
import subscriptionReducer from './reducers/global/subscription/subscriptionSlice';

const store = configureStore({
  reducer: {
    alert: alertReducer,
    diagram: diagramReducer,
    editor: editorReducer,
    edge: edgeReducer,
    history: historyReducer,
    inspector: inspectorReducer,
    node: nodeReducer,
    modal: modalReducer,
    folder: folderReducer,
    distributionBoard: distributionBoardReducer,
    view: viewReducer,
    subscription: subscriptionReducer
  }
})

export default store
